import React from 'react';
import { Check } from 'lucide-react';
interface PricingCardProps {
  title: string;
  price: string;
  originalPrice: string;
  features: string[];
  link: string;
  isPopular?: boolean;
  buttonText?: string;
}
export function PricingCard({
  title,
  price,
  originalPrice,
  features,
  link,
  isPopular = false,
  buttonText = 'COMPRAR AHORA'
}: PricingCardProps) {
  return <div className={`relative flex flex-col h-full rounded-2xl overflow-hidden ${isPopular ? 'border-2 border-orange-500 shadow-xl scale-105 z-10' : 'border border-stone-200 shadow-md bg-white'}`} data-id="element-257">
      {isPopular && <div className="bg-orange-500 text-white text-center py-1 text-sm font-bold uppercase tracking-wider" data-id="element-258">
          Más Vendido
        </div>}

      <div className={`p-6 flex-1 flex flex-col ${isPopular ? 'bg-orange-50' : 'bg-white'}`} data-id="element-259">
        <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-260">{title}</h3>

        <div className="flex items-baseline gap-2 mb-6" data-id="element-261">
          <span className="text-4xl font-extrabold text-stone-900" data-id="element-262">
            ${price}
          </span>
          <span className="text-lg text-stone-500 line-through decoration-red-500 decoration-2" data-id="element-263">
            ${originalPrice}
          </span>
        </div>

        <ul className="space-y-3 mb-8 flex-1" data-id="element-264">
          {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-265">
              <div className="mt-1 bg-green-100 rounded-full p-1 shrink-0" data-id="element-266">
                <Check className="w-3 h-3 text-green-700" data-id="element-267" />
              </div>
              <span className="text-stone-700 text-sm font-medium" data-id="element-268">
                {feature}
              </span>
            </li>)}
        </ul>

        <a href={link} className={`w-full py-4 px-6 rounded-lg font-bold text-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-lg ${isPopular ? 'bg-orange-600 text-white hover:bg-orange-700 shadow-orange-200' : 'bg-stone-800 text-white hover:bg-stone-900 shadow-stone-200'}`} data-id="element-269">
          {buttonText}
          <span className="block text-xs font-normal opacity-90 mt-1" data-id="element-270">
            Descarga Inmediata
          </span>
        </a>
      </div>
    </div>;
}